/**
 * This file has been added to avoid having to refactor the the knock-on effects of converting packages/web/src/utils/reselect/createDeepEqualSelector.js to TypeScript.
 */

import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export default createDeepEqualSelector;
